import React from "react";
import { Header } from "semantic-ui-react";

const RecoverFormHeader = () => {
  return (
    <>
      <Header as="h1" color="blue" textAlign="center" size="huge">
        Recupera tus accesos
      </Header>
      <Header as="h5" color="blue" textAlign="center">
        Recupera tu contraseña en 2 simples pasos
      </Header>
    </>
  );
};

export default RecoverFormHeader;
